import { useCMSPageField } from '@/cms/fields'
import { ProductAdsComponent } from '@/scopes/product-ads/components/ProductAds'
import { ProductAdsList } from '@/scopes/product-ads/components/ProductAdsList'
import { useDestinationFilteredProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { useMemo, useRef } from 'react'
import styles from './AccoTile.module.css'

interface AccoTileProductAdsProps {
  infoLabel: string
  infoContent: string
  headerTitle: string
  contextItemId: string
}

export function AccoTileProductAds({
  infoLabel,
  infoContent,
  headerTitle,
  contextItemId,
}: AccoTileProductAdsProps) {
  const regionId = useCMSPageField('PDP.regionId')
  const { isLoading, data = [] } = useDestinationFilteredProductAds({
    contextItemId,
    destinations: { Region: [regionId] },
    componentType: 'AccoList',
  })

  const productAdsRef = useRef<HTMLDivElement | null>(null)
  useProductAdsListViewed(data, 'sponsored_pdp', productAdsRef)

  const hasData = data.length > 0

  const content = useMemo(() => {
    if (isLoading || !hasData)
      return null

    return (
      <div className={styles.wrapper} data-qa="product-ads">
        <ProductAdsComponent
          infoLabel={infoLabel}
          infoContent={infoContent}
          headerTitle={headerTitle}
        >
          <ProductAdsList data={data} isLoading={isLoading} type="sponsored_pdp" />
        </ProductAdsComponent>
      </div>
    )
  }, [isLoading, hasData, data, infoLabel, infoContent, headerTitle])

  return <div ref={productAdsRef}>{content}</div>
}
